import useUnitFlashcards from '@/data/hook/unit/useUnitFlashcards';
import UnitShortcuts, { UnitShortcutsProps } from './UnitShortcuts';

type StudentUnitShortcutsProps = Omit<
  UnitShortcutsProps,
  'hasFlashcards' | 'pendingFlashcards'
>;

export default function StudentUnitShortcuts(props: StudentUnitShortcutsProps) {
  const { hasFlashcards, pendingCount } = useUnitFlashcards(
    props.contentLesson.id,
  );

  return (
    <UnitShortcuts
      {...props}
      hasFlashcards={hasFlashcards}
      pendingFlashcards={pendingCount}
    />
  );
}
